import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useAuth } from "../auth/AuthContext";
import { SignOutButton } from "./SignOutButton";

export const PageLayout = (props) => {
    const { isAuthenticated, auth } = useAuth();

    return (
        <>
            <Navbar bg="primary" variant="dark" style={{ padding: '0 16px' }}>
                <a className="navbar-brand" href="/">JKA Brasil</a>
                {isAuthenticated && (
                    <>
                        <span className="navbar-text text-white" style={{ marginLeft: 'auto', marginRight: '16px' }}>
                            {auth?.email}
                        </span>
                        <SignOutButton />
                    </>
                )}
            </Navbar>
            {props.children}
        </>
    );
};
